import { mapActions, mapState } from 'vuex' 

export default {
  data() {
    return {
      alert: false,
      filtersSlugs: [],
      datas: null,
      isOpen: false,
      isMobile: false,
      onLoad: false,
      select: null,
      innerWidth: window.innerWidth,
      selectActive: false,
      slugGA: null
    }
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  watch: {
    filtersSlugs()
    {
      // console.log('filtersSlugs change', this.filtersSlugs)
      // this.fetchData()
    }
  },
  methods: {
    onResize()
    {
      if(window.innerWidth <= 960){
        this.isMobile = true

        if(this.innerWidth != window.innerWidth)
          this.isOpen = false
      }else{
        this.isMobile = false
        this.isOpen = true
      }

      this.innerWidth = window.innerWidth
    },
    calcWidth(id)
    {
      let max =  Math.max.apply(Math, this.datas.answers.map(o => { return o.results } ))

      let answer = this.datas.answers.find(x => x.id === id)
      return 'calc(' + Number.parseFloat(answer.results).toFixed(0) * 100 / max + '% + 47px)' 
    },
    reset()
    {
      this.filtersSlugs = []
      this.select = null
      this.selectActive = false
      if(this.$refs.select && this.$refs.select[0])
        this.$refs.select[0].selectedIndex = 0
        
      this.fetchData()
    },
    toggleFilter(e)
    {
      let type = e.currentTarget ? e.currentTarget.nodeName : 'LI'
      let source = e.currentTarget ? e.currentTarget : this.$el.querySelector('.v-select')
      let slug
      let index
      
      console.log(type)
      if(type == 'BUTTON')
      {
        slug = source.dataset.slug 
        index = source.dataset.index
      }

      if(type == 'LI')
      {
        slug = this.select.slug 
        index = '9'
        this.selectActive = true
      }

      if(type == 'SELECT')
      {
        slug = source.options[source.selectedIndex].dataset.slug 
        index = source.options[source.selectedIndex].dataset.index
        this.selectActive = true
      }

      console.log(slug, index)

      let remove = false

      if(this.filtersSlugs.length == 2){
        this.alert = true
      }
      
      for (let i = 0; i < this.filtersSlugs.length; i++) {
        const filter = this.filtersSlugs[i];
        if(filter.slug === slug)
        {
          console.log('remove filter', slug)
          this.filtersSlugs.splice(i, 1)
          remove = true

          this.fetchData()

          if(type == 'LI')
          {
            this.select = null
          }

          break
        }

        if(filter.type === index)
        {
          console.log('filter ', index, ' is ', filter.slug, ' and change for ', slug)
          filter.slug = slug
          remove = true

          this.fetchData()

          // if(index == 8 && type != 'LI')
          // {
          //   this.select = null
          //   this.selectActive = false
          // }

          // if(index == 8 && type != 'SELECT')
          // {
          //   if(this.$refs.select && this.$refs.select[0]){
          //     this.$refs.select[0].selectedIndex = 0
          //     this.selectActive = false
          //   }
          // }

          break
        }
      }

      this.slugGA = slug
      if(this.filtersSlugs.length < 2 &&!remove){
        this.filtersSlugs.push({ type: index, slug: slug })
        this.fetchData()
      }
      else if(source && !source.slug && !remove)
      {
        source.selectedIndex = 0
      }else if(source && source.slug && !remove)
      {
        this.select = null
      }
    },
    fetchData()
    {
      console.log('fetchData')
      this.alert = false
      this.onLoad = true

      let filters = []
      this.filtersSlugs.forEach( el => {
        filters.push(el.slug) 
      })

      if(filters.length == 0)
      {
        filters.push('all')
        filters.push('all')
      }
      else if(filters.length == 1)
      {
        filters.push('all')
      }

      this.$api.getSurveyFilters(this.$route.params.slug, filters.join(',') )
      .then(response => {
        this.datas = response.data.data
        this.onLoad = false
        let label = this.select && this.select.name ? this.select.name.replace(/\s/g,'_') : this.slugGA
        this.$gtm.trackEvent({ category: 'button_donnees_filtre', action: 'click', label: this.$route.params.slug + '_filtre_' + label })
        this.$emit('filters', this.datas)
      })
    }
  },
  created()
  {
    this.datas = this.data

    this.onResize()
    window.addEventListener("resize", this.onResize)
  }
}
